export const STATUS_POLL_INTERVAL_MS = 20_000;
